<div class="dialog {{needsMessage ? 'message-required' : ''}}">
  <h2>{{label}}</h2>
    <div>
        <textarea id="formData" [(ngModel)]=rejectionMessage placeholder="Please write a message for the patient" (click)="resetMessageStatus()"></textarea>
        <div class="secure-message-buttons">
            <button class="secure-message-cancel" (click)="closeDialog()">Cancel</button>
            <button class="secure-message-submit" (click)="submitData()">Submit</button>
        </div>
    </div>
</div>
